import { Checkbox, Form, FormInstance, InputNumber, Space, Typography } from "antd";
import { useEffect } from "react";

interface IProps {
  form: FormInstance;
}
const BreakPenalty = ({ form }: IProps) => {
  const hasPenalty = Form.useWatch("penaltyForOverBreak", form);

  useEffect(() => {
    if (hasPenalty && !form.getFieldValue("breakMinutes") && !form.getFieldValue("penaltyOverBreakCount")) {
      form.setFieldsValue({ breakMinutes: 10}); // form.setFieldsValue({ breakMinutes: 10, penaltyOverBreakCount: 2 });
    } else if (!hasPenalty) {
      form.setFieldsValue({ breakMinutes: 0}); // form.setFieldsValue({ breakMinutes: 0, penaltyOverBreakCount: 0 });
    }
  }, [hasPenalty, form]);

  return (
    <div>
      <Form.Item
        label={
          <Typography.Title level={4} className="!m-0 cursor-pointer">
            Penalty for over break
          </Typography.Title>
        }
        layout="horizontal"
        name="penaltyForOverBreak"
        valuePropName="checked"
      >
        <Checkbox />
      </Form.Item>

      {hasPenalty ? (
        <Space>
          <Form.Item name={"breakMinutes"} label="Break minutes" rules={[{ required: hasPenalty }]} required={hasPenalty}>
            <InputNumber />
          </Form.Item>

          {/*<Form.Item name={"penaltyOverBreakCount"} label="Number of possible breaks" rules={[{ required: hasPenalty }]} required={hasPenalty}>*/}
          {/*  <InputNumber />*/}
          {/*</Form.Item>*/}
        </Space>
      ) : null}
    </div>
  );
};
export default BreakPenalty;
